<template lang='pug'>
div(v-if="priceGrid")
	div.tw-flex.tw-flex-row.tw-items-center.tw-wrap.tw-mb-4.tw-gap-2(v-if='!isSingle')
		template(v-for="(trainInfo, i) in trainsInfo" :key="i")
			div.tw-flex.tw-flex-col
				div.tw-flex.tw-items-center
					img.train-icon(v-if="trainInfo.icon" :src="trainInfo.icon")
					span.tw-font-bold {{trainInfo.name}}
				span.tw-font-medium {{trainInfo.startStation}} ({{ trainInfo.startDate }}) - {{trainInfo.endStation}} ({{ trainInfo.endDate }})
			div(v-if="i < trainsInfo.length - 1") +
	.tw-flex.tw-flex-col.price-table.tw-text-center
		div.tw-flex
			div(class="tw-basis-1/6")
			div.price-table-header-cell.price-table-cell.tw-basis-0.tw-flex.tw-flex-col.tw-items-center.tw-justify-center(
				v-for="column in columns"
				:key="column.id"
				:class="{'active': column.id == selectedCatalogServiceId}"
			)
				//span.mdi.mdi-information-outline(@click="infoService(column)")
				span(:style="column.display_name.length > 20 ? 'font-size: 0.75rem; font-weight: 500;' : ''") {{ column.display_name }}
		div.tw-flex.price-table-body-row(v-if='priceGrid.matrix' v-for="(row, krow) in rows" :key="krow")
			div.price-table-row-header-cell.tw-flex.tw-items-center.tw-justify-center.tw-gap-2(class="tw-basis-1/6" :class="{'active': row.id == selectedOfferId}")
				h5 {{ row.display_name }}
				span.mdi.mdi-information-outline.tw-cursor-pointer(@click="infoOffer(row.display_name)")
			price-cell.price-table-body-cell.price-table-cell.tw-basis-0(
				v-for="(col, kcol) in columns"
				:key="kcol"
				:columnId='col.id'
				:rowId='row.id'
				:travel-solution="travelSolution"
			)
	.tw-mt-5(v-if='selectedOffer')
		h4.tw-font-bold {{selectedOffer.display_name}}
		p.text-caption.mb-0 {{selectedOffer.description}}
		.tw-justify-start.tw-flex.tw-gap-2
			p.text-caption
				span.mdi.mdi-check-circle.tw-text-primary(v-if="selectedOffer.can_change")
				span.mdi.mdi-xamarin.tw-text-red-500(v-else) 
				| {{$t('sale.train_price_grid.change', 'Cambio')}}
			p.text-caption
				span.mdi.mdi-check-circle.tw-text-primary(v-if="selectedOffer.can_refund")
				span.mdi.mdi-xamarin.tw-text-red-500(v-else) 
				| {{$t('sale.train_price_grid.refund', 'Rimborso')}}
	div.tw-flex.tw-flex-col.tw-mt-4.tw-gap-4(v-if="showCartaFreccia")
		carta-freccia(v-for="(passenger, passengerIdx) in bookingStore.passengers" :required="cartaIsRequired" :key="passengerIdx" :passengerIdx="passengerIdx" :passenger="passenger" show-name :parameter-errors="bookingStore.travellerParameterErrors")
	div.tw-mt-5(v-if='selectedGridOffer && selectedGridOffer.offers' v-for='offer in selectedGridOffer.offers' :key='offer.id')
		p(v-if='offer.messages' v-for='(offerMessage, i) in offer.messages' :key='i') {{ offerMessage }}
</template>
	
<script setup>
import CartaFreccia from "@/sale/components/tab2_travel_solutions/cartaFreccia.vue";
import { useBookingStore } from '@/stores/booking';
import {provide} from "vue";
import PriceCell from './price-cell.vue';
import {usePriceGrid} from "@/sale/composables/price-grid";


const bookingStore = useBookingStore();
const props = defineProps({
	train: Object,
	travelSolution: Object,
	isSingle: {
		type: Boolean,
		default: true
	}
});
const {travelSolution} = props;
const {
	infoOffer, trainsInfo, priceGrid, columns, rows, selectedOfferId, selectedCatalogServiceId, selectedGridOffer,
	selectedOffer, cartaIsRequired, showCartaFreccia
} = usePriceGrid(travelSolution, props.train);


provide('train', props.train);
</script>

<style scoped>
img.train-icon {
  height: 0.8rem;
}
.price-table-cell{
	border: 0.063rem solid #e3e6ed;
	margin: 0 0.15rem;
	text-align: center;
	max-width: 6.875rem;
	padding: 1.5rem 0.25rem;
	position: relative;
	width: 100%;
	flex-grow: 1;
	flex-shrink: 0;
}
.price-table-body-cell{
	padding: 1.5rem 0.25rem;
	cursor: pointer;
}
.price-table-body-row:last-child .price-table-body-cell{
	border-bottom-left-radius: 0.5rem;
	border-bottom-right-radius: 0.5rem;
}
.price-table-body-cell.active{
	color: #fff;
	background-color: rgb(var(--v-theme-primary));
	border-color: rgb(var(--v-theme-primary));
}

.price-table-header-cell{
	min-height: 4.625rem;
	border-top-left-radius: 0.363rem;
	border-top-right-radius: 0.363rem;
	padding: 0.5rem 0.25rem;
	text-align: center;
}

.price-table-header-cell.active{
	border-top: 0.363rem solid rgb(var(--v-theme-primary-darken-1));
	padding-top: 0.2rem;
	box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.1);
}

.price-table-row-header-cell{
	margin: 0.323rem 0;
	border-bottom-left-radius: 0.363rem;
	border-top-left-radius: 0.363rem;
	display: flex;
	background: #f2f3f7;
	text-align: center;
}
.price-table-row-header-cell.active{
	border-left: 0.363rem solid rgb(var(--v-theme-primary-darken-1));
}

</style>